import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Skeleton, Typography } from '@mui/material';

const PublishChecklistItem = ({ title, description, status, loading }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'complete':
        return '#16A34A';
      case 'incomplete':
        return '#E52600';
      case 'in-progress':
        return '#FF9E3D';
      default:
        return '#9E9E9E';
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'start', px: 2, py: 1 }}>
        <Skeleton variant="circular" width={20} height={20} sx={{ mt: 0.5, flexShrink: 0 }} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="75%" height={28} />
          <Skeleton variant="text" width="90%" height={24} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'start', px: 2, py: 1 }}>
      <Box sx={{ pt: 0.5 }}>
        {status !== 'complete' ? (
          <ErrorIcon fontSize="small" sx={{ color: getStatusColor() }} />
        ) : (
          <CheckCircleIcon fontSize="small" sx={{ color: getStatusColor() }} />
        )}
      </Box>
      <Box>
        <Typography variant="h6" fontWeight="normal" sx={{ color: '#212121' }}>
          {title}
        </Typography>
        {status !== 'complete' && (
          <Typography variant="h6" fontWeight="normal" sx={{ color: '#858585' }}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PublishChecklistItem;
